const configNode = document.getElementById('spark-internet-cart-config');
let activationVariantId = '';
try {
  const config = configNode ? JSON.parse(configNode.textContent || '{}') : {};
  activationVariantId = config.activationVariantId ? String(config.activationVariantId) : '';
} catch (_) {}

function lockActivationControls() {
  if (!activationVariantId) return;
  const selector = `cart-quantity-selector-component[data-variant-id="${CSS.escape(activationVariantId)}"], quantity-selector-component[data-variant-id="${CSS.escape(activationVariantId)}"]`;
  for (const qty of document.querySelectorAll(selector)) {
    const row = qty.closest('.cart-items__table-row');
    if (!row) continue;
    row.classList.add('spark-internet-fee-line');

    const controls = row.querySelector('.cart-items__quantity-controls');
    if (controls) {
      controls.hidden = true;
      controls.setAttribute('aria-hidden', 'true');
      for (const button of controls.querySelectorAll('button')) {
        button.disabled = true;
        button.setAttribute('aria-disabled', 'true');
        button.tabIndex = -1;
      }
      for (const input of controls.querySelectorAll('input')) {
        input.disabled = true;
        input.tabIndex = -1;
      }
    }

    const remove = row.querySelector('.cart-items__remove');
    if (remove) {
      remove.disabled = true;
      remove.hidden = true;
      remove.setAttribute('aria-disabled', 'true');
      remove.tabIndex = -1;
    }

    const quantityCell = row.querySelector('.cart-items__quantity');
    if (quantityCell && !quantityCell.querySelector('.spark-internet-fee-required')) {
      const label = document.createElement('span');
      label.className = 'spark-internet-fee-required';
      label.textContent = 'Required one-time activation';
      quantityCell.append(label);
    }
  }
}

const observer = new MutationObserver(() => lockActivationControls());
observer.observe(document.documentElement, { childList: true, subtree: true });
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', lockActivationControls, { once: true });
} else {
  lockActivationControls();
}
